import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/contexts/LangContext";
import { X } from "lucide-react";

const STORAGE_KEY = "rh_cookie_consent";

const COPY = {
  de: {
    title: "Diese Website verwendet Cookies",
    body:
      "Wir nutzen ausschließlich technisch notwendige Cookies (Session, Sprach-Präferenz). Keine Tracker, kein Drittanbieter-Marketing.",
    accept: "Verstanden",
    privacy: "Datenschutz lesen",
  },
  en: {
    title: "This website uses cookies",
    body:
      "We use only technically necessary cookies (session, language preference). No trackers, no third-party marketing.",
    accept: "Got it",
    privacy: "Read privacy policy",
  },
  ru: {
    title: "Этот сайт использует куки",
    body:
      "Только технически необходимые куки (сессия, язык). Без трекеров и рекламы третьих сторон.",
    accept: "Понятно",
    privacy: "Политика конфиденциальности",
  },
  uk: {
    title: "Цей сайт використовує куки",
    body:
      "Лише технічно необхідні куки (сесія, мова). Без трекерів та реклами третіх сторін.",
    accept: "Зрозуміло",
    privacy: "Політика конфіденційності",
  },
};

export default function CookieBanner() {
  const { lang } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const v = localStorage.getItem(STORAGE_KEY);
    if (!v) {
      const id = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(id);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, "accepted");
    setVisible(false);
  };

  if (!visible) return null;
  const c = COPY[lang] || COPY.ru || COPY.de;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:bottom-6 md:left-6 md:right-auto md:max-w-md z-[60] border border-white/15 bg-[#051630]/95 backdrop-blur-xl p-6 shadow-2xl rh-fade-up"
    >
      <button
        onClick={accept}
        aria-label="Close"
        className="absolute top-3 right-3 text-white/40 hover:text-white"
        data-testid="cookie-close"
      >
        <X size={16} strokeWidth={1.5} />
      </button>
      <p className="text-[10px] tracking-[0.3em] uppercase text-white/50 mb-2">Cookies</p>
      <h3 className="font-display text-lg md:text-xl font-medium tracking-tight mb-3">
        {c.title}
      </h3>
      <p className="text-sm text-white/65 leading-relaxed">{c.body}</p>
      <div className="mt-5 flex items-center gap-4">
        <button
          onClick={accept}
          data-testid="cookie-accept"
          className="rh-btn-primary inline-flex items-center justify-center px-5 py-2.5 bg-white text-[#051630] font-bold tracking-[0.18em] uppercase text-[11px] border border-white"
        >
          <span>{c.accept}</span>
        </button>
        <Link
          to="/datenschutz"
          onClick={accept}
          data-testid="cookie-privacy-link"
          className="rh-link text-[11px] tracking-[0.18em] uppercase text-white/70 hover:text-white"
        >
          {c.privacy}
        </Link>
      </div>
    </div>
  );
}
